module.exports = __webpack_public_path__ + "img/B低通锐化200.c1d2cca4.png";